import { LeviarObject } from '../LeviarObject.js'
import type { LeviarObjectOptions } from '../types.js'
import { TextTransition } from './TextTransition.js'

export interface TextAttribute {
  text?: string
}

export class Text<
  D extends Record<string, any> = Record<string, any>
> extends LeviarObject<TextAttribute, D> {
  /** 트랜지션 진행도 (0 ~ 1, 1이면 완료 또는 미실행) */
  __transitionProgress: number = 1

  /** 전환 관리자 */
  private transitioner?: TextTransition

  constructor(options?: LeviarObjectOptions<TextAttribute, D>) {
    super('text', options)
  }

  /**
   * 지정된 속도로 텍스트가 글자 단위로 타이핑되듯 서서히 나타나는 효과를 줍니다.
   * @param newText 변경할 새 텍스트
   * @param charDurationMs 글자 1개당 나타나는데 걸리는 시간(밀리초)
   */
  transition(newText: string, charDurationMs: number): TextTransition {
    if (!this.transitioner) {
      this.transitioner = new TextTransition(this)
    }
    this.transitioner.start(newText, charDurationMs)
    return this.transitioner
  }
}
